// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__ui8Iq","noMargins":"icon_noMargins__mr0H1","warning":"icon_warning__2Oag-","transparent":"icon_transparent__3Qkf4"};